/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */
//入口
import { taskDownloadList } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { date } from 'xrk-tools';

//初始化
export let example = new TableRenderClass({ fields, search });

// 页面入口
let downPart = example.createPart({
  name: '下载中心',
  search: search,
  list: param => {
    return new Promise(resolve => {
      Object.keys(param);
      taskDownloadList({
        ...param,
        startDate:
          param.startDate === undefined
            ? date.dateFormat(
                new Date().getTime() - 1000 * 60 * 60 * 24 * 30,
                'Y-M-D'
              )
            : param.startDate,
        endDate:
          param.endDate === undefined
            ? date.dateFormat(new Date(), 'Y-M-D')
            : param.endDate
      }).then(res => {
        resolve(res);
      });
    });
  },
  requestNow: true,
  fields: [
    'index',
    'downloadName',
    'fileSize',
    'status',
    'baseInfoMixValue',
    'downloadDt',
    'operatorName',
    'operation'
  ]
});
/*主页面入口*/
export const main = [{ name: '下载中心', childMenu: [downPart] }];
